import { createSlice } from '@reduxjs/toolkit'

export const valueSlice = createSlice({
  name: 'value',
  initialState: {
    viewSearchProfile: false,
    searchPageLoad: false,
    profileSearch: false,
    filterValue: null,
    requestShow: false,
    userData: [],
    userMessage: [],
    isChatOpen: false,
    isPaymentOpen: false,
    paymentUser: [],
    viewFromRequests: false
  },
  reducers: {
    setValue: (state, action) => {
      return { ...state, ...action.payload }
    },
    removeValue: () => {
      return null
    },
    setSearchUserData: (state, action) => {
      state.userData = action.payload;
    },
    clearSearchUserData: (state) => {
      state.userData = [];
    },
    toggleSearchPageLoad: (state) => {
      state.searchPageLoad = !state.searchPageLoad;
    },
    setUserMessage: (state, action) => {
      state.userMessage = action.payload;
    },
    clearUserMessage: (state) => {
      state.userMessage = [];
    },
    setIsChatOpen: (state, action) => {
      state.isChatOpen = action.payload
    },
    setIsPaymentOpen: (state, action) => {
      state.isPaymentOpen = action.payload
    },
    setPaymentUser: (state, action) => {
      state.paymentUser = action.payload
    }
  },
})

export const { setValue,
  removeValue,
  setSearchUserData,
  clearSearchUserData,
  toggleSearchPageLoad,
  setUserMessage,
  clearUserMessage,
  setIsChatOpen,
  setIsPaymentOpen,
  setPaymentUser
} = valueSlice.actions

export default valueSlice.reducer